<template>
    <aside class="copyright grid" v-if="showPartial">
        <div class="grid--container">
            <div class="copyright--content">
                <div class="copyright--row grid--row">
                    <div class="grid--col" v-for="(plugin, index) in plugins">
                        <component :is="plugin.type" :plugin="plugin"></component>
                    </div>
                </div>
            </div>
        </div>
    </aside>
</template>

<script>
    import cmsPartial from 'vue/mixins/cms/cms-partial';


    export default {
        mixins: [
            cmsPartial,
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?5130e50e